<template>
  <div id="notice-dialog" class="ui modal notice-modal">
    <div class="notice-modal__header">
      <div class="notice-modal__eyebrow">
        <span class="notice-modal__info-dot" aria-hidden="true">⚠</span>
        <span>重要なお知らせ</span>
      </div>
      <h2 class="notice-modal__title">直電の仕組み・紹介手数料についてのご案内</h2>
    </div>

    <div class="scrolling content notice-modal__body">
      <div class="notice-modal__panel">
        <div class="notice-modal__agreement-head">
          <h3 class="notice-modal__agreement-title">確認対象：直電の仕組み・紹介手数料について</h3>
          <span class="notice-modal__required-badge">確認必須</span>
        </div>

        <div class="notice-modal__agreement-inner">
          <p class="notice-modal__intro">
            平素より、グルプラをご利用いただき、誠にありがとうございます。<br />
            施設様に安心してサービスをご利用いただくため、グルプラの「直電」の仕組みと「紹介手数料」の考え方について、改めてご案内いたします。<br />
            お手数ですが、以下の内容をご確認ください。
          </p>

          <article>
            <div class="notice-modal__section-heading">
              <div class="notice-modal__section-number">1</div>
              <h3 class="notice-modal__section-title">直電について</h3>
            </div>
            <div class="notice-modal__section-content">
              <p>
                直電とは、グルプラ上の施設ページや電話導線から、ユーザーが施設様へ直接お電話できる仕組みです。
              </p>
              <p>
                「今すぐ空き状況を確認したい」「電話で相談したい」「そのまま予約したい」といったユーザーを施設様へスムーズにつなぐことで、予約機会を逃さないことを目的としています。
              </p>
              <p>
                また、問い合わせ内容の確認、成約確認、トラブル防止、サービス品質向上のため、通話内容を録音する場合があります。録音された通話内容は、店舗管理画面の「直電詳細」ページから、AIによる要約や自動文字起こしとあわせてご確認いただけます。
              </p>
              <p>
                直電をきっかけに宴会・貸切・パーティー等の予約が成立した場合は、グルプラ経由の送客として、ご契約内容に基づき紹介手数料の請求対象となります。
              </p>
              <p>
                直電の仕組みについては、以下の動画でもご案内しております。
              </p>
              <a
                class="notice-modal__video-link"
                href="https://youtu.be/JoKvdjoL9b8"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span class="notice-modal__play-icon" aria-hidden="true">▶</span>
                <span>
                  <span class="notice-modal__video-title">直電の仕組みについて（動画）</span>
                  <span class="notice-modal__video-url">https://youtu.be/JoKvdjoL9b8</span>
                </span>
              </a>
            </div>
          </article>

          <article>
            <div class="notice-modal__section-heading">
              <div class="notice-modal__section-number">2</div>
              <h3 class="notice-modal__section-title">紹介手数料について</h3>
            </div>
            <div class="notice-modal__section-content">
              <p>
                グルプラでは、ご契約内容に基づき、成約金額をもとに紹介手数料を算出しております。
              </p>
              <p>
                紹介手数料は、契約で定めた手数料率を成約金額に適用して算出し、その紹介手数料に対して消費税を加算してご請求いたします。
              </p>
              <p>
                この消費税は、グルプラが施設様へ提供する送客・紹介サービスに対して課税されるものであり、成約金額に含まれる消費税へ重ねて課税するものではありません。
              </p>
              <p>
                紹介手数料の考え方については、以下の動画でもご案内しております。
              </p>
              <a
                class="notice-modal__video-link"
                href="https://youtu.be/vLE5m-beIvM"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span class="notice-modal__play-icon" aria-hidden="true">▶</span>
                <span>
                  <span class="notice-modal__video-title">紹介手数料について（動画）</span>
                  <span class="notice-modal__video-url">https://youtu.be/vLE5m-beIvM</span>
                </span>
              </a>
            </div>
          </article>

          <section class="notice-modal__confirmation-box" aria-labelledby="notice-confirmation-title">
            <h3 class="notice-modal__confirmation-title" id="notice-confirmation-title">確認内容</h3>
            <ul class="notice-modal__confirmation-list">
              <li>直電は、グルプラ経由でユーザーが施設様へ直接電話できる仕組みであること</li>
              <li>直電では、問い合わせ内容の確認、成約確認、トラブル防止、サービス品質向上のため、通話内容を録音する場合があること</li>
              <li>録音された通話内容は、店舗管理画面から確認できること</li>
              <li>直電経由で予約・成約した場合は、ご契約内容に基づき紹介手数料の請求対象となること</li>
              <li>紹介手数料は、ご契約内容に基づいて算出され、その紹介手数料に対して消費税が加算されること</li>
            </ul>
            <div class="notice-modal__note">
              <strong>※</strong>
              <span>動画は補足説明です。動画をご視聴いただかなくても、上記内容をご確認いただければ確認手続きを行えます。</span>
            </div>
            <p class="notice-modal__support-text">
              ご不明な点がございましたら、ご契約内容や該当案件の通話内容を確認のうえ、個別にご説明いたしますので、お気軽にグルプラサポートまでお問い合わせください。
            </p>
          </section>
        </div>
      </div>
    </div>

    <div class="actions notice-modal__footer">
      <div class="notice-modal__check-panel">
        <label class="notice-modal__confirm-check">
          <input type="checkbox" v-model="confirmed">
          <span>
            <span class="notice-modal__required">必須</span>
            上記の内容を確認しました。
          </span>
        </label>
      </div>
      <div class="notice-modal__actions">
        <div class="notice-modal__status-text">
          {{ confirmed ? '確認内容の保存に進めます。' : 'チェックを入れると「確認して閉じる」を押せます。' }}
        </div>
        <button
          class="ui button notice-modal__primary-button"
          type="button"
          :class="{ disabled: !confirmed || submitting }"
          :disabled="!confirmed || submitting"
          @click="acknowledge"
        >
          確認して閉じる
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      confirmed: false,
      submitting: false,
      _resolveShow: null,
    };
  },
  methods: {
    async showIfNeeded() {
      try {
        const response = await this.createForm().get('/shopadmin/api/notices');
        if (response.data.acknowledged) {
          return;
        }
        return new Promise((resolve) => {
          this._resolveShow = resolve;
          this.open();
        });
      } catch (e) {
        // 取得失敗時は業務継続を優先してモーダルを出さない
      }
    },
    open() {
      this.$nextTick(() => {
        $('#notice-dialog').modal({
          closable: false,
          allowMultiple: true,
          autofocus: false,
          observeChanges: true,
        }).modal('show');
      });
    },
    close() {
      $('#notice-dialog').modal('hide');
    },
    acknowledge() {
      if (!this.confirmed || this.submitting) {
        return;
      }
      this.submitting = true;
      this.createForm().post('/shopadmin/api/notices/acknowledge', () => {
        this.close();
        this.submitting = false;
        if (this._resolveShow) {
          this._resolveShow();
          this._resolveShow = null;
        }
      }, () => {
        this.submitting = false;
        alert('確認の保存に失敗しました。時間をおいて再度お試しください。');
      });
    },
  },
};
</script>

<style>
.ui.modal.notice-modal {
  width: min(1280px, calc(100vw - 64px));
  max-height: min(92vh, 980px);
}

.notice-modal__header {
  min-height: 70px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
  padding: 18px 22px;
  border-bottom: 1px solid #d6d6d6;
  background: #ff100f;
}

.notice-modal__eyebrow {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #fff;
  font-size: 19px;
  font-weight: 700;
}

.notice-modal__info-dot {
  font-size: 22px;
  font-weight: 800;
  line-height: 1;
}

.notice-modal__title {
  margin: 0;
  color: #fff;
  font-size: 20px;
  line-height: 1.35;
}

.notice-modal__body {
  padding: 20px 28px 28px !important;
}

.notice-modal__panel {
  border: 2px solid #c7c7c7;
  border-radius: 4px;
  background: #fff;
}

.notice-modal__agreement-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 22px;
  border-bottom: 1px solid #dddddd;
  background: #fafafa;
}

.notice-modal__agreement-title {
  margin: 0;
  color: #202020;
  font-size: 18px;
  line-height: 1.45;
}

.notice-modal__required-badge {
  flex: 0 0 auto;
  min-width: 72px;
  padding: 6px 10px;
  border-radius: 4px;
  background: #d9534f;
  color: #fff;
  text-align: center;
  font-size: 13px;
  font-weight: 800;
}

.notice-modal__agreement-inner {
  padding: 22px 28px 24px;
}

.notice-modal__intro {
  margin: 0 0 22px;
  color: #3f3f3f;
  font-size: 15px;
  line-height: 1.85;
}

.notice-modal__section-heading {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0 0 10px;
  margin-top: 22px;
  border-bottom: 1px solid #eeeeee;
}

.notice-modal__section-number {
  flex: 0 0 auto;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #4a4a4a;
  color: #fff;
  display: grid;
  place-items: center;
  font-weight: 800;
  font-size: 14px;
}

.notice-modal__section-title {
  margin: 0;
  color: #202020;
  font-size: 16px;
  line-height: 1.4;
}

.notice-modal__section-content {
  padding: 14px 0 4px;
}

.notice-modal__section-content p {
  margin: 0 0 12px;
  color: #3f3f3f;
  font-size: 15px;
  line-height: 1.8;
}

.notice-modal__section-content p:last-child {
  margin-bottom: 0;
}

.notice-modal__video-link {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  min-height: 56px;
  margin: 16px 0 0;
  padding: 13px 15px;
  border: 1px solid #c9d8f6;
  border-radius: 4px;
  background: #f6f9ff;
  color: #1d55e8;
  text-decoration: none;
}

.notice-modal__play-icon {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: #1d55e8;
  color: #fff;
  display: grid;
  place-items: center;
  font-size: 15px;
  flex: 0 0 auto;
}

.notice-modal__video-title {
  display: block;
  font-size: 14px;
  font-weight: 800;
  line-height: 1.45;
}

.notice-modal__video-url {
  display: block;
  color: #777777;
  font-size: 12px;
  line-height: 1.45;
  overflow-wrap: anywhere;
}

.notice-modal__confirmation-box {
  border-top: 1px solid #eeeeee;
  padding: 20px 0 0;
  margin-top: 20px;
}

.notice-modal__confirmation-title {
  margin: 0 0 12px;
  color: #202020;
  font-size: 16px;
  line-height: 1.45;
}

.notice-modal__confirmation-list {
  margin: 0;
  padding-left: 20px;
  color: #3f3f3f;
  font-size: 14px;
  line-height: 1.75;
}

.notice-modal__confirmation-list li {
  margin-bottom: 7px;
}

.notice-modal__note {
  display: flex;
  gap: 8px;
  align-items: flex-start;
  padding: 11px 12px;
  margin-top: 14px;
  border-radius: 4px;
  background: #fff8e8;
  color: #6d4d12;
  font-size: 13px;
  line-height: 1.6;
}

.notice-modal__support-text {
  margin: 14px 0 0;
  color: #3f3f3f;
  font-size: 14px;
  line-height: 1.75;
}

.notice-modal__footer {
  display: block !important;
  padding: 18px 24px !important;
  border-top: 1px solid #dddddd;
  background: #f7f7f7;
  text-align: left !important;
}

.notice-modal__check-panel {
  border: 2px solid #c7c7c7;
  border-radius: 4px;
  background: #fff;
  padding: 16px 18px;
  margin-bottom: 14px;
}

.notice-modal__confirm-check {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin: 0;
  color: #202020;
  font-size: 14px;
  line-height: 1.7;
  cursor: pointer;
}

.notice-modal__confirm-check input {
  width: 20px;
  height: 20px;
  margin-top: 2px;
  flex: 0 0 auto;
}

.notice-modal__required {
  color: #b54c4c;
  font-weight: 800;
}

.notice-modal__actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
}

.notice-modal__status-text {
  color: #777777;
  font-size: 13px;
  line-height: 1.5;
}

.notice-modal__primary-button {
  min-width: 120px !important;
  min-height: 52px !important;
  border: 0 !important;
  border-radius: 4px !important;
  background: #168a43 !important;
  color: #fff !important;
  font-size: 14px !important;
  font-weight: 800 !important;
}

.notice-modal__primary-button.disabled,
.notice-modal__primary-button:disabled {
  background: #dddddd !important;
  color: #6d6d6d !important;
  opacity: 1 !important;
  cursor: not-allowed !important;
}

@media (max-width: 760px) {
  .ui.modal.notice-modal {
    width: 100% !important;
    max-height: none;
    margin: 0 !important;
    border-radius: 0 !important;
  }

  .notice-modal__header,
  .notice-modal__body,
  .notice-modal__footer {
    padding-left: 18px !important;
    padding-right: 18px !important;
  }

  .notice-modal__agreement-head {
    display: block;
  }

  .notice-modal__required-badge {
    display: inline-block;
    margin-top: 10px;
  }

  .notice-modal__agreement-inner {
    padding: 18px;
  }

  .notice-modal__video-link {
    align-items: flex-start;
  }

  .notice-modal__actions {
    display: grid;
    grid-template-columns: 1fr;
  }

  .notice-modal__primary-button {
    width: 100% !important;
  }
}
</style>
